module.exports = __webpack_public_path__ + "static/media/friend_finder.0e1689dd.png";